import React from 'react';

const ReplyItem = ({ currentUser, reply, parentReply, onPressReplyButton }) => {
  if (!reply || !reply.user || !currentUser || reply.is_deleted) {
    return null;
  }

  const MultiLineBody = () => {
    if (!reply.reply) return null;
    
    const texts = reply.reply.split('\n').map((item, index) => {
      const isLast = index === reply.reply.split('\n').length - 1;
      const regexp_url = /https?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+/g;
      const regexp_makeLink = url => {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      };

      item = item.replace(regexp_url, regexp_makeLink(item));

      return (
        <div key={index}>
          <div dangerouslySetInnerHTML={{ __html: item }} />
          {!isLast && <br />}
        </div>
      );
    });

    return <p className="mb-0">{texts}</p>;
  };

  const getUserName = reply => {
    let userName = '';

    if (reply) {
      if (reply.companies_user) {
        const isRealNameRequired =
          reply.companies_user.company.is_real_name_required;
        userName = isRealNameRequired
          ? reply.companies_user.view_full_name_disp
          : reply.companies_user.nickname;
      } else if (reply.user && reply.user.tunagate_id) {
        userName = reply.user.tunagate_id;
      }
    }
    
    return userName;
  };

  const ParentReplyBody = () => {
    return (
      <div className="d-flex justify-content-around align-items-start border-bottom pb-3 mb-3">
        <div className="pr-2">
          <img
            data-src={parentReply.companies_user
              ? (parentReply.companies_user ? parentReply.companies_user.avatar_thumb : '' ) 
              : (parentReply.user ? parentReply.user.avatar_thumb : '')}
            className="lazyload rounded-circle"
            alt="reply-user-image"
            width={36}
          />
        </div>
        <div className="flex-fill">
          <div className="d-flex justify-content-between pl-1">
            <div className="mb-0 pl-0">
              <p className="text-fz-xs text-black-20 mb-1 line-1 p-0">
                @{getUserName(parentReply)}
              </p>
            </div>
          </div>
          {parentReply.image_url_medium ? (
            <div>
              {parentReply.reply && (
                <div className="text-fz-10px">
                  {parentReply.reply.slice(0, 24)}
                  {parentReply.reply.length > 24 && '...'}
                </div>
              )}
              <div className="message-photo">
                <img
                  src={parentReply.image_url_medium}
                  style={{ width: '100%', maxWidth: '100px' }}
                />
              </div>
            </div>
          ) : (
            parentReply.reply && (
              <div className="text-fz-10px">
                {parentReply.reply.slice(0, 24)}
                {parentReply.reply.length > 24 && '...'}
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  return (
    <li>
      <div className="row justify-content-around align-items-start m-0 mb-3">
        <div className="col-2 pr-1 pt-4">
          <img
            data-src={reply.companies_user
              ? (reply.companies_user ? reply.companies_user.avatar_thumb : '' ) 
              : (reply.user ? reply.user.avatar_thumb : '')}
            className="lazyload rounded-circle"
            alt="reply-user-image"
            width={40}
          />
        </div>
        <div className="col-7 pl-0 pr-1">
          <div className="d-flex justify-content-between pl-1">
            <div className="mb-0 pl-0">
              <p className="text-fz-xs text-black-20 mb-1 line-1 p-0">
                @{getUserName(reply)}
              </p>
            </div>
          </div>
          {reply.image_url_medium ? (
            <div>
              {reply.reply && (
                <div className="card border-0 bg-gray mb-2 py-3 px-2 text-fz-12px">
                  {parentReply && <ParentReplyBody />}
                  <MultiLineBody />
                </div>
              )}
              <div className="message-photo">
                <img
                  src={reply.image_url_medium}
                  style={{ width: '100%', maxWidth: '320px' }}
                />
              </div>
            </div>
          ) : (
            <div className="card border-0 bg-gray mb-0 py-3 px-2 text-fz-12px">
              {parentReply && <ParentReplyBody />}
              <MultiLineBody />
            </div>
          )}
        </div>
        <div
          onClick={() => onPressReplyButton()}
          className="col-2 p-0 align-self-end"
        >
          <div style={{ width: '20px' }}>
            <svg
              className="text-gray"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M8.3 189.8L184.3 37.9C199.7 24.5 224 35.3 224 56v80.1c160.6 1.8 288 34 288 186.3 0 61.4-39.6 122.3-83.3 154.1-13.7 9.9-33.1-2.5-28.1-18.6 45.3-145-21.5-183.5-176.6-185.7V360c0 20.7-24.3 31.5-39.7 18.2l-176-152c-11.1-9.6-11.1-26.8 0-36.3z" />
            </svg>
          </div>
          <p className="text-fz-xs mb-0 text-gray">
            {reply.created_at_time_ago_format}
          </p>
        </div>
      </div>
    </li>
  );
};

export default ReplyItem;
